import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { CrudService } from 'src/app/services/crud.service';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import { DxColorBoxModule, DxDataGridComponent, DxDataGridModule, DxLoadPanelModule } from 'devextreme-angular';
import { NotifyService } from 'src/app/services/notify.service';
import { JoyrideModule } from 'ngx-joyride';
import { JourneyService } from 'src/app/services/journey.service';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';
@Component({
    selector: 'app-slot-types',
    templateUrl: './slot-types.component.html',
    styleUrls: ['./slot-types.component.css'],
    imports: [ DxDataGridModule, DxColorBoxModule, DxLoadPanelModule, JoyrideModule, PageHeaderComponent ],
    standalone: true
})
export class SlotTypesComponent implements AfterViewInit {
  public dataSource: CustomStore;
  private apiUrl: string = environment.baseApiUrl;
  editSlotTypes: boolean;
  storePositions: any[] = [];
  loading: boolean = false;
  weekCount: Array<number> = Array(20).fill(0).map((_, index) => index + 1);
  @ViewChild("slotTypesGrid", { static: false }) public dataGrid: DxDataGridComponent;
  constructor(private crudService: CrudService,
    private confirmationService:ConfirmationService,
    private horizontalMenuService:HorizontalMenuService,
    private notifyService:NotifyService,
    private journeyService: JourneyService) {
    this.dataSource = new CustomStore<any>({
      key: 'id',
      load: async () => {
        this.loading = true;
        return await new Promise((resolve) => {
          this.crudService.getData(`${this.apiUrl}slot-types`).subscribe((result: any) => {
            this.loading = false;
            resolve({data: result, totalCount: result.length});
          })
        })
      },
      insert: async (values) => {
        this.loading = true;
        const userDetails = localStorage.getItem('userDetails');
        const parsedDetails = JSON.parse(userDetails || '{}');
        values.group_id = parsedDetails.data.group_id;
        values.location_id = parsedDetails.data.location_id;
        return await new Promise(async (resolve) => {
          const result: any = await this.crudService.insertData(`${this.apiUrl}slot-types`, values)
          .subscribe((result: any) => {
            this.loading = false;
            this.notifyService.tellUser(result);
            resolve(result);
          });
        });
      },
      update: async (key, values) => {
        this.loading = true;
        console.log(key, values);
        return await new Promise(async (resolve) => {
          const result: any = await this.crudService.updateData(`${this.apiUrl}slot-types`, key, values)
          .subscribe((result: any) => {
            this.loading = false;
            this.notifyService.tellUser(result);
            resolve(result);
          });
        });
      },
      remove: async (key) => {
        this.loading = true;
        return await new Promise(async (resolve) => {
          const result: any = await this.crudService.deleteData(`${this.apiUrl}slot-types`, key)
          .subscribe((result: any) => {
            this.loading = false;
            this.notifyService.tellUser(result);
            resolve(result);
          });
        });
      }
    })
    this.horizontalMenuService.editSlotTypes$.subscribe((value: boolean) => {
      this.editSlotTypes = value;
      this.crudService.getData(`${this.apiUrl}store-positions`).subscribe((result: any) => {
        this.storePositions = result.data;
      });
    });
  }

  ngAfterViewInit(): void {
    this.journeyService.tryStartPhase('settings-slot-types');
  }

  onColorValueChanged(e: any, cellData: any) {
    cellData.setValue(e.value);
    //e.component.cellValue(e.rowIndex, 'color', e.value);
  }

  onCellPrepared(e: any) {  
    if (e.rowType === "data" && e.column.dataField == "colour") {  
      e.cellElement.style.backgroundColor = e.value;  
      }  
  }  

  onHiding(event:any){
    this.confirmationService.checkUnsaved(event, this.dataGrid, (value:boolean) => this.horizontalMenuService.seteditSlotTypes(value))
  }
}
